import React from "react";

export const ChevronM = ({ className = "", ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M8 10L4 6L5.4 4.6L8 7.2L10.6 4.6L12 6L8 10Z"
      fill="currentColor"
    />
  </svg>
);


